<template>
  <div class="main-content">
    <div class="check-in-detail-page">
      <div class="container">
        <div class="check-in-function">
          <h2 class="check-in-function__detail">
            {{ branch.name }} {{ course.name }} {{ date }}
            {{ scheduleTime.start_at }} {{ teacher.name }}
          </h2>

          <button class="excel-btn transparent-btn" @click="exportLogs">
            匯出excel
          </button>
          <router-link :to="{ name: 'QRcode頁面' }" class="qr-btn custom-btn">
            QRCODE顯示
          </router-link>
        </div>

        <div class="sort-row">
          <div class="sort-row__title">
            排序
          </div>

          <ul class="sort-row__menu">
            <li>
              <input
                id="expire"
                v-model="sortWith"
                type="radio"
                value="program_end_at"
              />
              <label for="expire" @click="changeSortWay">
                到期日
                <span
                  v-if="sortWith == 'program_end_at'"
                  :class="sortIconClass"
                />
              </label>
            </li>
            <li>
              <input
                id="checkIn"
                v-model="sortWith"
                type="radio"
                value="is_check_in"
              />
              <label for="checkIn" @click="changeSortWay">
                報到
                <span v-if="sortWith == 'is_check_in'" :class="sortIconClass" />
              </label>
            </li>
            <li>
              <input
                id="canUseTime"
                v-model="sortWith"
                type="radio"
                value="program_last_number"
              />
              <label for="canUseTime" @click="changeSortWay">
                可用次數
                <span
                  v-if="sortWith == 'program_last_number'"
                  :class="sortIconClass"
                />
              </label>
            </li>
            <li>
              <input
                id="oweMoney"
                v-model="sortWith"
                type="radio"
                value="order_unpaid_amount"
              />
              <label for="oweMoney" @click="changeSortWay">
                欠費
                <span
                  v-if="sortWith == 'order_unpaid_amount'"
                  :class="sortIconClass"
                />
              </label>
            </li>
          </ul>
        </div>

        <div class="check-in-area row">
          <OneCard
            v-for="(card, index) in dataList"
            :key="index"
            :card="card"
            :scheduleTime="scheduleTime"
            @checkin="checkedHandler"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OneCard from '@/components/CheckInDetail/OneCard';
import { fetchScheduleTime } from '@/api/schedule_time';
import { exportLogs } from '@/api/course_check_in_log';
import _ from 'lodash';
import { fetchCheckInList } from '@/api/course';

export default {
  components: {
    OneCard
  },
  data() {
    return {
      sortWith: 'program_end_at',
      dataList: [],
      sortWay: false,
      // Store the meta element
      viewport_meta: document.getElementById('viewport-meta'),
      // Define our viewport meta values
      viewports: {
        default: 'width=device-width',
        landscape: 'width=1400'
      },
      path: this.$route.path,
      schedule_time_id: this.$route.params.schedule_time_id,
      date: this.$route.params.date,
      scheduleTime: {}
    };
  },
  computed: {
    teacher() {
      return _.get(this.scheduleTime, 'user', {});
    },
    branch() {
      return _.get(this.scheduleTime, 'branch', {});
    },
    course() {
      return _.get(this.scheduleTime, 'course', {});
    },
    fileName() {
      return `${this.date}_${this.branch.name}_${this.course.name}報到紀錄`;
    },
    query() {
      return {
        sortType: this.sortWay === false ? 'desc' : 'asc',
        sortBy: this.sortWith
      };
    },
    sortIconClass() {
      return [this.sortWay ? 'icon-arrow_u2' : 'icon-arrow_d2'];
    }
  },
  watch: {
    sortWith() {
      this.fetchCheckInLogs();
    },
    sortWay() {
      this.fetchCheckInLogs();
    }
  },
  created() {
    // 來到這個頁面,viewport設成有手機版的頁面
    this.viewportSet(this.viewport_meta, this.viewports);

    this.fetchScheduleTime();
  },
  beforeRouteLeave(to, from, next) {
    // 離開這個頁面,viewport設回只有電腦版寬度
    this.viewportSetWideVersion(this.viewport_meta, this.viewports);
    next();
  },
  methods: {
    changeSortWay() {
      this.sortWay = !this.sortWay;
    },
    viewportSet(viewport_meta, viewports) {
      if (screen.width > 768) {
        viewport_meta.setAttribute('content', viewports.landscape);
      } else {
        viewport_meta.setAttribute('content', viewports.default);
      }
    },
    viewportSetWideVersion(viewport_meta, viewports) {
      viewport_meta.setAttribute('content', viewports.landscape);
    },
    fetchScheduleTime() {
      fetchScheduleTime(
        { id: this.schedule_time_id, date: this.date },
        scheduleTime => {
          this.scheduleTime = scheduleTime;
          this.fetchCheckInLogs();
        }
      );
    },
    async exportLogs() {
      let loader = await this.$loading.show();

      await exportLogs({
        schedule_time_id: this.schedule_time_id,
        branch_id: this.branch.branch_id,
        course_id: this.course.course_id,
        date: this.date,
        fileName: this.fileName
      });

      loader.hide();
    },
    checkedHandler() {
      this.fetchCheckInLogs();
    },
    fetchCheckInLogs() {
      fetchCheckInList(
        {
          course_id: this.course.course_id,
          date: this.date,
          branch_id: this.branch.branch_id,
          schedule_time_id: this.schedule_time_id,
          ...this.query
        },
        data => {
          this.dataList = data;
        }
      );
    }
  }
};
</script>
